import { CreatePOReceiptsRequestObject } from "../api/PurchaseOrderLines";
import { POReceiptData } from "../models/purchase-order";
import { getCurrentDateString } from "./DateHelper";

type getCreatePOReceiptsPayloadParams = {
  data: POReceiptData;
  supplierReturnFlag: boolean;
  receivedComplete: boolean;
  transactionQuantity: number;
  billOfLading: string;
  comments: string;
  employee: string;
  bin?: string;
};
export function getCreatePOReceiptsPayload(
  params: getCreatePOReceiptsPayloadParams
): CreatePOReceiptsRequestObject {
  const {
    data,
    receivedComplete,
    supplierReturnFlag,
    transactionQuantity,
    billOfLading,
    comments,
    employee,
    bin,
  } = params;
  const { Item, ChangeOrder, Line, PurchaseOrder, Release, StoresLocation } =
    data;

  return {
    BillOfLading: billOfLading,
    Comments: comments,
    Employee: employee,
    Item,
    TransactionQuantity: transactionQuantity,
    Bin: bin,
    ChangeOrder,
    DateCharged: getCurrentDateString(),
    LabelPrintCopies: 0,
    LabelTemplateName: "PO Delivery Receipts",
    PoLine: Line,
    PurchaseOrder,
    ReceivedComplete: receivedComplete,
    Release,
    StoresLocation,
    SupplierReturnFlag: supplierReturnFlag,
  };
}

export function getConfirmation() {
  return {
    RuleConfirmationDetailsList: [
      {
        MessageId: "ItemWarnQtyOnHandNegative",
        MessageConfirmationValue: {
          val1: "Y",
        },
      },
      {
        MessageId: "QtyRecMoreQtyOrderW",
        MessageConfirmationValue: {
          val1: "Y",
        },
      },
      {
        MessageId: "AmtRcvdMorePctAmtOrdWarn",
        MessageConfirmationValue: {
          val1: "Y",
        },
      },
    ],
  };
}
